export default __webpack_public_path__ + "static/media/LO02b.e726870a.mp3";